/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React, { useEffect } from "react";
import { checkToken } from "../../../services/localStorage";
import { logout } from "../../../store/login/actions";
import { Navigate, Outlet, useLocation } from "react-router";
import { useCustomer } from "../../../provider/Customer/CustomerProvider";
import ConsentUpdateModal from "../../ConsentUpdateModal/ConsentUpdateModal";
import LayoutAuthenticated from "@/src/containers/Layouts/LayoutAuthenticated";

export default function AuthenticatedRoutes() {
  const { customer, isLoading } = useCustomer();
  const location = useLocation();
  const isAuthenticated = checkToken(localStorage.getItem("token"), customer);

  useEffect(() => {
    if (!!customer && !isAuthenticated) {
      logout();
    }
  }, [customer, isAuthenticated]);

  if (!customer && isLoading) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to={"/login"} state={{ from: location }} replace />;
  }

  return (
    <>
      <ConsentUpdateModal />
      <Outlet />
    </>
  );
}
